import { debounce } from '../../../static/template-gispen/js/utils/debounce';
import ScriptLoader from '../../../static/template-gispen/js/utils/ScriptLoader';
//Country ADM0_A3_IS list from: https://data.opendatasoft.com/explore/dataset/ne_10m_admin_0_countries%40public-us/table/?flg=fr

class Map {
  constructor(element, options) {
    this._element = element;
    this._options = { ...Map.options, ...options };
    this._loadMarker = this._loadMarker.bind(this);
    this._resize = this._resize.bind(this);
    this._handleCountryClick = this._handleCountryClick.bind(this);
    //this._cacheSelectors()
    ScriptLoader.load(this._options.mapbox)
      .then(() => {
        this._mapboxgl = window.mapboxgl;

        this._cacheSelectors();
        this._initialize();
      })
      .catch(console.error);
  }

  static options = {
    mapbox: 'https://api.mapbox.com/mapbox-gl-js/v1.6.1/mapbox-gl.js',
    markerOffset: -12,
    token:
      'pk.eyJ1IjoiZGlnaXRhbGFocmVuZCIsImEiOiJjazFhbzlmZXcwMW5nM2lwZzY0NGJmNmpkIn0.7nLzgRJsxvqGT9s2P1KmEg',
    countries1: {
      'id': 'countries1',
      'source': {
        type: 'vector',
        url: 'mapbox://digitalahrend.9ehtxvyo',
      },
      'source-layer': 'ne_10m_admin_0_countries-167gff',
      'type': 'fill',
      'paint': {
        'fill-color': '#4A566B',
      },
    },
    countries2: {
      'id': 'countries2',
      'source': {
        type: 'vector',
        url: 'mapbox://digitalahrend.9ehtxvyo',
      },
      'source-layer': 'ne_10m_admin_0_countries-167gff',
      'type': 'fill',
      'paint': {
        'fill-color': '#4A566B',
      },
    },
    countries3: {
      'id': 'countries3',
      'source': {
        type: 'vector',
        url: 'mapbox://digitalahrend.9ehtxvyo',
      },
      'source-layer': 'ne_10m_admin_0_countries-167gff',
      'type': 'fill',
      'paint': {
        'fill-color': '#848e9f',
      },
    },
    lines: {
      'id': 'lines',
      'source': {
        type: 'vector',
        url: 'mapbox://digitalahrend.9ehtxvyo',
      },
      'source-layer': 'ne_10m_admin_0_countries-167gff',
      'type': 'line',
      'paint': {
        'line-color': '#ffffff',
      },
    },
    water: {
      'id': 'water',
      'source': {
        type: 'vector',
        url: 'mapbox://mapbox.mapbox-streets-v8',
      },
      'source-layer': 'water',
      'type': 'fill',
      'paint': {
        'fill-color': '#FFFFFF',
      },
    },
    zoom: 1,
    minzoom: 1,
    maxzoom: 1,
    debounceTime: 100,
    mobileBreakpoint: 720,
  };

  _state = {
    markerPopup: null,
    hoveredCountryId: null,
    popOpen: null,
    hasPopup: false,
    typeone: [],
    typetwo: [],
    typethree: [],
    mobile: false,
  };

  _cacheSelectors() {
    this._mapboxgl.accessToken = this._options.token;
    this._elements = {
      markers: [...this._element.querySelectorAll(this._options.markers)],
      map: new this._mapboxgl.Map({
        container: 'map__window',
        style: 'mapbox://styles/digitalahrend/ck1aq3hz409oz1cl8ttkcckq5?optimize=true',
        zoom: this._options.zoom,
        center: [parseFloat(this._options.lng), parseFloat(this._options.lat)],
        maxZoom: parseFloat(this._options.maxzoom),
        minZoom: parseFloat(this._options.minzoom),
        crossOrigin: 'anonymous',
      }),
      typeone: [...this._element.querySelectorAll(this._options.typeone)],
      typetwo: [...this._element.querySelectorAll(this._options.typetwo)],
      typethree: [...this._element.querySelectorAll(this._options.typethree)],
    };
  }

  _initialize() {
    this._resize();

    window.addEventListener(
      'resize',
      debounce(() => {
        this._resize();
      }, this._options.debounceTime)
    );

    /* eslint-disable prefer-destructuring */
    const _options = this._options;
    this._mapboxgl.accessToken = this._options.token;
    const map = this._elements.map;
    map.scrollZoom.disable();

    /* eslint-enable */
    map.addControl(new this._mapboxgl.NavigationControl());

    this._elements.markers.forEach((marker) => {
      this._loadMarker(marker);
    });

    this._elements.typeone.forEach((filter) => {
      const code = filter.getAttribute('data-ref');
      this._state.typeone.push(code);
    });

    this._elements.typetwo.forEach((filter) => {
      const code = filter.getAttribute('data-ref');
      this._state.typetwo.push(code);
    });

    this._elements.typethree.forEach((filter) => {
      const code = filter.getAttribute('data-ref');
      this._state.typethree.push(code);
    });

    map.on('load', () => {
      map.addLayer(_options.countries1);
      map.addLayer(_options.countries2);
      map.addLayer(_options.countries3);
      map.addLayer(_options.water);
      map.addLayer(_options.lines);

      map.setFilter('countries1', ['in', 'ADM0_A3_IS'].concat(...this._state.typeone));
      map.setFilter('countries2', ['in', 'ADM0_A3_IS'].concat(...this._state.typetwo));
      map.setFilter('countries3', ['in', 'ADM0_A3_IS'].concat(this._state.typethree));
    });

    map.on('click', 'countries2', (e) => {
      const features = map.queryRenderedFeatures(e.point, {
        layers: ['countries2'],
      });
      const type = 2;
      this._handleCountryClick(e, features, type);
    });

    map.on('click', 'countries3', (e) => {
      const features = map.queryRenderedFeatures(e.point, {
        layers: ['countries3'],
      });
      const type = 3;
      this._handleCountryClick(e, features, type);
    });
  }

  _handleCountryClick(e, features, type) {
    if (this._state.hasPopup) {
      return;
    }
    if (this._state.popOpen === null) {
      /* eslint-disable prefer-destructuring */
      const map = this._elements.map;
      const feature = features[0];
      /* eslint-enable */
      const country = feature.properties.ADM0_A3_IS;
      const filter = this._element.querySelector(`[data-ref="${country}"][data-type="${type}"]`);
      const header = '<div class="map__marker_info">';
      let fig = null;
      let figure = '';
      fig = filter.querySelector('figure');
      if (fig !== null) {
        figure = fig.innerHTML;
      }
      let link = '';
      const linkMarker = filter.querySelector('.map__country__link');
      if (linkMarker !== null) {
        link = linkMarker.innerHTML;
      }
      const text = '<div class="map__marker_text">';
      const name = `<h3>${filter.querySelector('.map__country__name').innerHTML}</h3>`;
      const title = `<h3>${filter.querySelector('.map__country__title').innerHTML}</h3>`;
      const address = `<div class="map__marker__address">${
        filter.querySelector('.map__country__address').innerHTML
      }</div>`;
      const phone = `<div class="map__marker__phone">${
        filter.querySelector('.map__country__phone').innerHTML
      }</div>`;
      const footer = '</div></div>';
      const html = header + figure + text + name + title + address + phone + link + footer;
      const popup = new this._mapboxgl.Popup()
        .setLngLat(map.unproject(e.point))
        .setHTML(html)
        .addTo(map);
      this._state.popOpen = popup;
      popup.on('close', () => {
        this._state.hasPopup = false;
        this._state.markerPopup = null;
        this._state.popOpen = null;
      });
    } else {
      this._state.popOpen.remove();
      this._state.popOpen = null;
    }
  }

  _resize() {
    this._state.mobile =
      window.innerWidth < this._options.mobileBreakpoint ||
      document.documentElement.clientWidth < this._options.mobileBreakpoint ||
      document.body.clientWidth < this._options.mobileBreakpoint;

    if (this._state.mobile) {
      this._elements.map.dragRotate.disable();
      this._elements.map.scrollZoom.disable();
      this._elements.map.touchZoomRotate.disable();
    } else {
      this._elements.map.dragRotate.enable();
      this._elements.map.scrollZoom.enable();
      this._elements.map.touchZoomRotate.enable();
    }
  }

  _loadMarker(marker) {
    /* eslint-disable prefer-destructuring */
    const _state = this._state;
    const map = this._elements.map;
    /* eslint-enable */
    const el = document.createElement('div');
    let brand = 'ahrend';
    if (marker.getAttribute('data-brand')) {
      brand = marker.getAttribute('data-brand');
    }
    el.className = `map-marker ${brand.toLowerCase()}`;
    const header = '<div class="map__marker_info">';
    let fig = null;
    let figure = '';
    let link = '';
    fig = marker.querySelector('figure');
    if (fig !== null) {
      figure = fig.innerHTML;
    }
    const linkMarker = marker.querySelector('.map__marker__link');
    if (linkMarker !== null) {
      link = linkMarker.innerHTML;
    }

    const text = '<div class="map__marker_text">';
    const title = `<h3>${marker.querySelector('.map__marker__title').innerHTML}</h3>`;
    const address = `<div class="map__marker__address">${
      marker.querySelector('.map__marker__address').innerHTML
    }</div>`;
    const phone = `<div class="map__marker__phone">${
      marker.querySelector('.map__marker__phone').innerHTML
    }</div>`;
    const lng = parseFloat(marker.querySelector('.map__marker__lng').textContent);
    const lat = parseFloat(marker.querySelector('.map__marker__lat').textContent);
    const footer = '</div></div>';
    const content = header + figure + text + title + address + phone + link + footer;

    const popup = new this._mapboxgl.Popup({ offset: 8 }).setHTML(content);

    new this._mapboxgl.Marker(el, {
      offset: [0, this._options.markerOffset],
    })
      .setLngLat([lng, lat])
      .setPopup(popup)
      .addTo(map);

    popup.on('close', () => {
      _state.hasPopup = false;
      _state.markerPopup = null;
      _state.popOpen = null;
      const x = document.getElementsByClassName('active-marker');
      let i = 0;
      for (i = 0; i < x.length; i++) {
        x[i].classList.remove('active-marker');
      }
    });

    popup.on('open', () => {
      const popups = [...document.querySelectorAll('.mapboxgl-popup')];
      popups.forEach((pop) => {
        const img = pop.querySelectorAll('img');
        if (img.length > 0) {
          pop.classList.remove('no-figure');
        } else {
          pop.classList.add('no-figure');
        }
      });
    });

    el.addEventListener('click', (e) => {
      _state.hasPopup = true;
      if (_state.markerPopup === null) {
        _state.markerPopup = popup;
      } else {
        _state.markerPopup.remove();
        _state.markerPopup = popup;
      }
      map.flyTo({ center: [lng, lat], zoom: 4 });
      const x = document.getElementsByClassName('active-marker');
      let i = 0;
      for (i = 0; i < x.length; i++) {
        x[i].classList.remove('active-marker');
      }
      e.currentTarget.classList.add('active-marker');
    });
  }
}

export default Map;
